// List of possible actions taken by the searchbox
// The searchbox can:
export var Actions;
(function (Actions) {
    // receive focus
    Actions["INPUT_FOCUS"] = "INPUT_FOCUS";
    // lose focus
    Actions["INPUT_BLUR"] = "INPUT_BLUR";
    // intercept keyup
    Actions["KEYUP_CAPTURE"] = "KEYUP_CAPTURE";
    // KeyUp Escape
    Actions["KEYUP_ESCAPE"] = "KEYUP_ESCAPE";
    // detect that the input have changed
    Actions["INPUT_CHANGED"] = "INPUT_CHANGED";
    // Checks for a prefix
    Actions["CHECK_PREFIX"] = "CHECK_PREFIX";
    // do the search thing
    Actions["PREPARE_FINDER"] = "PREPARE_FINDER";
    // keyword lookup
    Actions["CHECK_KEYWORD"] = "CHECK_KEYWORD";
    // add a "chip"
    Actions["ADD_FILTER_CHIP"] = "ADD_FILTER_CHIP";
    // remove a "chip"
    Actions["REMOVE_FILTER_CHIP"] = "REMOVE_FILTER_CHIP";
    // autocomplete click
    Actions["AUTOCOMPLETE_CLICK"] = "AUTOCOMPLETE_CLICK";
    // searchbox submitted
    Actions["SEARCHBOX_SUBMITTED"] = "SEARCHBOX_SUBMITTED";
    // Updating SerachBox value
    Actions["UPDATE_VALUE"] = "UPDATE_VALUE";
    // reset
    Actions["RESET"] = "RESET";
})(Actions || (Actions = {}));
